var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hostel-description"},[(!_vm.hideTitle)?_c('h4',[_vm._v("Описание")]):_vm._e(),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }